import { ModuleWithSlides } from "shared/lib/interfaces/Module";
import apiAxios from "../../apiAxios";

export default async function getModules(): Promise<ModuleWithSlides[]> {
  const response = await apiAxios.get("/modules");
  return response.data;
}
